import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchContacts } from "./helpAndAssistantApi";

interface MyKnownError {
  errorMessage: string;
  // ...
}

export interface ContactAttributes {
  id: string;
  role: string;
  name: string;
  designation: string;
  groupId: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
  status: string;
}
export interface ContactModel {
  groupName: string;
  ethicsTeamDetails: Array<ContactAttributes>;
}

export interface ContactsState {
  contacts: Array<ContactModel>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: ContactsState = {
  contacts: [],
  status: "idle",
};

export const GetContacts = createAsyncThunk(
  "Contacts/fetch",
  async (data: any) => {
    const response = await fetchContacts(data);
    return response;
  }
);

export const ContactsSlice = createSlice({
  name: "Contacts",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetContacts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetContacts.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetContacts.fulfilled, (state, action) => {
        state.status = "idle";
        state.contacts = action?.payload;
        // console.log(action?.payload,"action?.payload;action?.payload;")
      });
  },
});

export const {} = ContactsSlice.actions;

export const selectContacts = (state: RootState) => {
  return state.ContactsReducer.contacts;
};
export default ContactsSlice.reducer;
